<div class="registration-card d-flex flex-column">
  <div [@openClose]="!isButtonClicked ? 'open' : 'closed'">
    <h3 class="warning" i18n="@@registration.invalid.text-expired">
      Your activation link has expired
    </h3>
    <img
      class="d-block ml-auto me-auto"
      src="/assets/animation/link-expired.gif"
      alt="link-expired-animation"
      width="170px"
      height="170px"
      loading="lazy"
    />
    <button
      (click)="onResendClick()"
      i18n="@@registration.invalid.text-resend-link"
    >
      RESEND THE LINK
    </button>
  </div>
  <div
    [@openClose]="
      isButtonClicked && !hasError && isEmailSent ? 'open' : 'closed'
    "
  >
    <h3 i18n="@@registration.invalid.text-activation-link">
      An activation link has been resent to your registered email address
    </h3>
  </div>
  <div
    [@openClose]="
      isButtonClicked && !hasError && !isEmailSent ? 'open' : 'closed'
    "
  >
    <h3 i18n="@@registration.text-email-already-exists">
      Looks like your account is already registered,
      <a href="/auth/login">login to continue.</a>
    </h3>
  </div>
  <div [@openClose]="isButtonClicked && hasError ? 'open' : 'closed'">
    <h3 i18n="@@registration.token-does-not-exist">
      We could not resend the link. Please sign up again.
    </h3>
    <button (click)="onSignUpClick()" i18n="@@global.sign-up">SIGN UP</button>
  </div>
  <div>
    <a href="/">
      <div
        class="signup-logo mt-4"
        [ngStyle]="{
          'background-image': 'url(' + backgroundImage + ')',
        }"
      ></div>
    </a>
  </div>
</div>
